import React from "react";
import { Box, Typography, Link as MuiLink, Divider } from "@mui/material";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        mt: "auto",
        py: 3,
        px: 2,
        textAlign: "center",
        borderTop: 1,
        borderColor: "divider",
      }}
    >
      <Typography variant="body2" color="text.secondary">
        <MuiLink component={Link} to="/privacy-policy" color="inherit" underline="hover">
          Privacy Policy
        </MuiLink>
        <Box component="span" sx={{ mx: 1 }}>
          •
        </Box>
        <MuiLink component={Link} to="/terms" color="inherit" underline="hover">
          Terms and Conditions
        </MuiLink>
      </Typography>
      <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: "block" }}>
        © {new Date().getFullYear()} Gleason Development LLC. All rights reserved.
      </Typography>
    </Box>
  );
};

export default Footer;
